import Vue from "vue";
import Vuex from "vuex";
import { Exhibition } from "@/interfaces";

Vue.use(Vuex);

export default new Vuex.Store<State>({
  state: {
    menuOpen: false,
    loaded: true,
    hero: {},
    images: {},
    rotaChrom: {},
    privacyPolicy: {},
    heidolph: {},
    exhibitions: [],
    footer: [],
  },
  mutations: {
    setMenuOpen(state, payload: boolean) {
      state.menuOpen = payload;
    },
    setLoaded(state) {
      state.loaded = true;
    },
    setHero(state, payload) {
      state.hero = { ...payload };
    },
    setRotaChrom(state, payload) {
      state.rotaChrom = { ...payload };
    },
    setHeidolph(state, payload) {
      state.heidolph = { ...payload };
    },
    setExhibitions(state, payload) {
      state.exhibitions = payload;
    },
    setPrivacyPolicy(state, payload) {
      state.privacyPolicy = payload;
    },
    setImages(state, payload) {
      state.images = payload;
    },
    setFooter(state, payload) {
      state.footer = payload;
    },
  },
  actions: {},
  modules: {},
  plugins: [],
});
interface State {
  menuOpen: boolean;
  loaded: boolean;
  hero: any;
  images: any;
  rotaChrom: any;
  heidolph: any;
  privacyPolicy: any;
  exhibitions: Exhibition[];
  footer: any;
}
